import '../components/SoftwareProductDesign/software-design.css'
import Header from "../components/SoftwareProductDesign/Header";
import Services from '../components/SoftwareProductDesign/Services';
import Tools from '../components/SoftwareProductDesign/Tools';
import ChooseIndustry from '../components/SoftwareProductDesign/ChooseIndustry';

import TransitionPage from '../utils/TransitionPage';

import { Helmet } from 'react-helmet-async';

const SoftwareProductDesign = () => { 
    return(
        <>
            <Helmet>
                <title>Product Design & UX | Advante Digital</title>
                <meta name="description" content="We improve real product flows, dashboards, forms, and user experiences so existing platforms become easier to use, support, and maintain."/>
                <meta name="keywords" content="product design, UX, dashboards, user flows, admin UX, existing platforms, usability"/>
            </Helmet>
            <Header />
            <Services />
            <Tools />
            <ChooseIndustry />
        </>
    );
}

export default TransitionPage (SoftwareProductDesign);